// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusBar_root__cyB3C","barContainer":"StatusBar_barContainer__uIOIq","bar":"StatusBar_bar__fqXu_"};